import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { LitresModalProps } from './LitresModal';

export const openLitresModal = ({ onClose, ...data }: LitresModalProps) =>
    openPopupHelper({ popupName: popupNames.LITRES_MODAL, data, onClose });

export const closeLitresModal = () => closePopupHelper(popupNames.LITRES_MODAL);
